<template>
  <div class="flex flex-wrap gap-1">
    <TimeTrackingButton title="U Burgstraße" :bigButton="false" @onButtonClick="onBurgstrasseClick" />
    <TimeTrackingButton title="Bus Hammerbrook Süd" :bigButton="false" @onButtonClick="onHammerbrookClick" />
    <TimeTrackingButton title="S Hammerbrook Süd" :bigButton="false" @onButtonClick="onSHammerbrookClick" />
    <TimeTrackingButton title="Berliner Tor" :bigButton="false" @onButtonClick="onBerlinerTorClick" />
    <TimeTrackingButton title="Landwehr" :bigButton="false" @onButtonClick="onLandwehrClick" />
  </div>
  <div v-if="station == 'burgstrasse'">
    <div class="text-left">
      Station: Burgstraße
    </div>
    <div class="text-left">
      {{ stationBurgstrasseData.data.time.date }} {{ stationBurgstrasseData.data.time.time }}
    </div>
    <hr>

    <template v-for="departure in stationBurgstrasseData.data.departures"  :key="departure.serviceId">
      <HvvDepartures :departure="departure" :time="timeToInt"/>
      <hr>
    </template>
  </div>
  <div v-if="station == 'hammerbrook'">
    <div class="text-left">
      Station: Bus Hammerbrook Süd
    </div>
    <div class="text-left">
      {{ stationHammerbrookData.data.time.date }} {{ stationHammerbrookData.data.time.time }}
    </div>
    <hr>

    <template v-for="departure in stationHammerbrookData.data.departures"  :key="departure.serviceId">
      <HvvDepartures :departure="departure" :time="timeToInt"/>
      <hr>
    </template>
  </div>
  <div v-if="station == 's_hammerbrook'">
    <div class="text-left">
      Station: S Hammerbrook Süd
    </div>
    <div class="text-left">
      {{ stationSHammerbrookData.data.time.date }} {{ stationSHammerbrookData.data.time.time }}
    </div>
    <hr>

    <template v-for="departure in stationSHammerbrookData.data.departures"  :key="departure.serviceId">
      <HvvDepartures :departure="departure" :time="timeToInt"/>
      <hr>
    </template>
  </div>
  <div v-if="station == 'berliner_tor'">
    <div class="text-left">
      Station: Berliner Tor
    </div>
    <div class="text-left">
      {{ stationBerlinerTorData.data.time.date }} {{ stationBerlinerTorData.data.time.time }}
    </div>
    <hr>

    <template v-for="departure in stationBerlinerTorData.data.departures"  :key="departure.serviceId">
      <HvvDepartures :departure="departure" :time="timeToInt"/>
      <hr>
    </template>
  </div>
  <div v-if="station == 'landwehr'">
    <div class="text-left">
      Station: Landwehr
    </div>
    <div class="text-left">
      {{ stationLandwehrData.data.time.date }} {{ stationLandwehrData.data.time.time }}
    </div>
    <hr>

    <template v-for="departure in stationLandwehrData.data.departures"  :key="departure.serviceId">
      <HvvDepartures :departure="departure" :time="timeToInt"/>
      <hr>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import TimeTrackingButton from "./guiComponents/TimeTrackingButton.vue"
import HvvDepartures from "./HvvDepartures.vue"

export default {
  name: "HvvStations",
  components: {
    TimeTrackingButton,
    HvvDepartures,
  },
  data() {
    return {
      station: '',
    }
  },
  computed: {
    ...mapGetters("stations", {
      stationBurgstrasseData: "stationBurgstrasseData",
      stationHammerbrookData: "stationHammerbrookData",
      stationSHammerbrookData: "stationSHammerbrookData",
      stationBerlinerTorData: "stationBerlinerTorData",
      stationLandwehrData: "stationLandwehrData",
    }),
    timeToInt() {
      let timeSplit = []
      if (this.station == 'burgstrasse') {
        timeSplit = this.stationBurgstrasseData.data.time.time.split(':')
      }
      if (this.station == 'hammerbrook') {
        timeSplit = this.stationHammerbrookData.data.time.time.split(':')
      }
      if (this.station == 's_hammerbrook') {
        timeSplit = this.stationSHammerbrookData.data.time.time.split(':')
      }
      if (this.station == 'berliner_tor') {
        timeSplit = this.stationBerlinerTorData.data.time.time.split(':')
      }
      if (this.station == 'landwehr') {
        timeSplit = this.stationLandwehrData.data.time.time.split(':')
      }
      if (timeSplit.length == 2) {
        return parseInt(timeSplit[0] * 60 + parseInt(timeSplit[1]))
      }
      return 0
    },
  },
  created() { },
  methods: {
    ...mapActions("stations", {
      getBurgstrasse: "getBurgstrasse",
      getHammerbrook: "getHammerbrook",
      getSHammerbrook: "getSHammerbrook",
      getBerlinerTor: "getBerlinerTor",
      getLandwehr: "getLandwehr",
    }),
    onBurgstrasseClick() {
      this.station = "burgstrasse"
      this.getBurgstrasse()
    },
    onHammerbrookClick() {
      this.station = "hammerbrook"
      this.getHammerbrook()
    },
    onSHammerbrookClick() {
      this.station = "s_hammerbrook"
      this.getSHammerbrook()
    },
    onBerlinerTorClick() {
      this.station = "berliner_tor"
      this.getBerlinerTor()
    },
    onLandwehrClick() {
      this.station = "landwehr"
      this.getLandwehr()
    },
  },
}
</script>
